export default __webpack_public_path__ + "static/media/Warlord's Pendant of Shielding.c2e5d42c.jpg";